import React, { createContext, useContext, useState, useEffect } from "react";

import axios from "axios";

// Set axios baseURL if backend is on a different port
axios.defaults.baseURL = process.env.REACT_APP_API_BASE || "https://studio-kosmos-backend-production.up.railway.app";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Try to load user from localStorage/token on mount
    const token = localStorage.getItem("token");
    if (token) {
      // Set default Authorization header for all axios requests
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      axios.get("/api/admin/me")
        .then(res => setUser(res.data.admin || res.data))
        .catch(() => setUser(null))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  function login({ username, password }) {
    return axios.post("/api/admin/login", { username, password })
      .then(res => {
        localStorage.setItem("token", res.data.token);
        setUser(res.data.admin);
        // Set default Authorization header for all future axios requests
        axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
        return res.data.admin;
      });
  }

  function logout() {
    localStorage.removeItem("token");
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
